"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = __importDefault(require("debug"));
var constants_1 = require("@app/shared/constants");
var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "info";
    LogLevel["WARN"] = "warn";
    LogLevel["ERROR"] = "error";
    LogLevel["DEBUG"] = "debug";
})(LogLevel || (LogLevel = {}));
var APP_NAME = 'hasbro-blast';
var Log = /** @class */ (function () {
    function Log() {
        debug_1.default.enable(APP_NAME + ":*");
        debug_1.default.log = console.log.bind(console); // eslint-disable-line no-console
    }
    Log.prototype.info = function (message, source) {
        this.buildMessage(LogLevel.INFO, message, source);
    };
    Log.prototype.warn = function (message, source) {
        this.buildMessage(LogLevel.WARN, message, source);
    };
    Log.prototype.error = function (message, source) {
        this.buildMessage(LogLevel.ERROR, message, source);
    };
    Log.prototype.debug = function (message, source) {
        var env = process.env.NODE_ENV;
        if (localStorage && ('function' === typeof localStorage.getItem)) {
            env = localStorage.getItem(constants_1.BLAST_ENV) || env;
        }
        if (env !== 'pd' && env !== 'production') {
            this.buildMessage(LogLevel.DEBUG, message, source);
        }
    };
    Log.prototype.buildMessage = function (level, message, source) {
        var createDebug = debug_1.default(APP_NAME + ":" + level);
        if (source) {
            createDebug(source, message);
        }
        else {
            createDebug(message);
        }
    };
    return Log;
}());
var log = new Log();
exports.default = log;
